"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBox = exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_system_1 = require("styled-system");
const tools_1 = require("../../tools");
const Box_1 = require("../Box");
const ButtonGroup_1 = require("../ButtonGroup");
exports.Button = react_1.forwardRef(function Button(_a, ref) {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    const { inGroup } = react_1.useContext(ButtonGroup_1.ButtonGroupContext);
    return (jsx_runtime_1.jsx(exports.StyledBox, Object.assign({ "data-ui-type": "button", ref: ref, py: 2, px: 3, backgroundColor: inGroup ? 'transparent' : 'primary', color: inGroup ? 'inherit' : 'primaryText', fontFamily: "inherit", fontWeight: "bold", fontSize: inGroup ? 'inherit' : 'md', border: "none", borderRadius: 3, lineHeight: "inherit", as: "button", onClick: onClick, noWrap: true, _hover: inGroup && !props.variant ? { backgroundColor: 'rgba(125,125,125,0.15)' } : {}, _disabled: { opacity: 0.3 } }, props), void 0));
});
exports.StyledBox = tools_1.styled(Box_1.Box) `
  cursor: pointer;

  ${styled_system_1.variant({
    variants: {
        link: {
            backgroundColor: 'transparent',
            color: 'inherit',
            fontWeight: 'bold',
            p: 0,
            display: 'inline-block',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        text: {
            backgroundColor: 'transparent',
            color: 'inherit',
            fontWeight: 'inherit',
            p: 0,
            display: 'inline-block',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        primary: {
            backgroundColor: 'accent',
            color: 'accentBackgroundedText',
        },
        secondary: {
            backgroundColor: 'muted',
            color: '#000',
        },
        outline: {
            backgroundColor: 'transparent',
            color: 'accent',
            border: '1px solid #ccc',
            borderColor: 'accent',
            borderRadius: 2,
            transition: 'background-color .1s',
            '&:hover': {
                backgroundColor: 'accent',
                color: 'accentBackgroundedText',
            },
        },
        outlinePrimary: {
            backgroundColor: 'transparent',
            color: 'primary',
            border: '1px solid #ccc',
            borderColor: 'primary',
            borderRadius: 2,
            transition: 'background-color .1s',
            '&:hover': {
                backgroundColor: 'primary',
                color: '#fff',
            },
        },
        'action-table-icon': {
            backgroundColor: 'transparent',
            color: 'inherit',
            whiteSpace: 'nowrap',
            '&:hover,&:focus': {
                backgroundColor: 'rgba(125,125,125,0.2)',
            },
        },
        'delete-table-icon': {
            backgroundColor: 'transparent',
            color: 'danger',
            whiteSpace: 'nowrap',
            '&:hover,&:focus': {
                backgroundColor: 'danger',
                color: '#fff',
            },
        },
        'floating-action': {
            width: '2.5rem',
            height: '2.5rem',
            borderRadius: '50%',
            textAlign: 'center',
            boxShadow: '0 0 20px rgba(0,0,0,0.1)',
            px: 0,
            py: 0,
        },
    },
})}
`;
//# sourceMappingURL=index.js.map